import Service from '../../balancer-farm-subgraph.service';
import queryBuilder from './query';
import { BaseFlakeInfos, QueryBuilder } from '../../types';

export default class baseFlakeInfos {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<BaseFlakeInfos[]> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data.baseFlakeInfos;
  }
}
